import { useQuery } from '@tanstack/react-query';
import { taxonomyService } from '@/services/taxonomyService';
import { queryKeys } from '@/libs/queryKeys';
import type { TaxonomyItem } from '@/types/echo_creation';

interface UseTaxonomyReturn {
  domains: TaxonomyItem[];
  categories: TaxonomyItem[];
  isLoading: boolean;
}

export const useTaxonomy = (): UseTaxonomyReturn => {
  const domainsQuery = useQuery({
    queryKey: queryKeys.taxonomy.domains,
    queryFn: taxonomyService.getDomains,
    staleTime: 5 * 60 * 1000,
  });

  const categoriesQuery = useQuery({
    queryKey: queryKeys.taxonomy.categories,
    queryFn: taxonomyService.getCategories,
    staleTime: 5 * 60 * 1000,
  });

  return {
    domains: domainsQuery.data ?? [],
    categories: categoriesQuery.data ?? [],
    isLoading: domainsQuery.isLoading || categoriesQuery.isLoading,
  };
};
